exports.addTrailingSlash = (url) => {
  if (url?.endsWith('/')) return url

  return `${url}/`
}
